import VMenu from './VMenu'

VMenu.install = function install (Vue) {
  Vue.component(VMenu.name, VMenu)
}

export default VMenu



// WEBPACK FOOTER //
// ./src/components/VMenu/index.js